import { DateRange } from "@/components/dateRange";
import { FilterApplicableFor } from "@/components/tags/types";
import SavedFilters from "@/components/tags/SavedFilters";
import useFiltersBySearchParams from "@/helpers/useFiltersBySearchParams";
import { useExplorerFiltersFromUrl } from "../hooks";
import { FilterSelectorDropdown } from "./filters";
import styles from "../styles.module.scss";

interface ExplorerFiltersDropdownProps {
  showColumnPicker?: boolean;
  /** Hide the saved-filters + filter-selector + date-range controls.
   *  Used on the Priority tab where these controls don't drive the query. */
  showFilters?: boolean;
}

export const ExplorerFiltersDropdown = ({
  showColumnPicker = false,
  showFilters = true,
}: ExplorerFiltersDropdownProps) => {
  const { startDate, endDate } = useExplorerFiltersFromUrl();
  const { updateSearchParamsByKey } = useFiltersBySearchParams();

  return (
    <div className={styles.dropdowns}>
      {showFilters && (
        <>
          <SavedFilters applicableFor={FilterApplicableFor.DISCOVER} />
          <FilterSelectorDropdown />
          <DateRange
            startDate={startDate}
            endDate={endDate}
            availableStaticRanges={["Last day", "Last 7 days", "Last 28 days"]}
            disableCalendarSelection
            onDateRangeSelect={(s, e) => {
              updateSearchParamsByKey({
                start_date: s?.toISOString(),
                end_date: e?.toISOString(),
              });
            }}
          />
        </>
      )}
      {showColumnPicker && <div id={"opportunities-column-picker"}></div>}
    </div>
  );
};
